import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { I18n } from 'core';

import Button from 'components/Button/Button';
import { navigate } from 'navigation';
import SectionWrapper from 'components/SectionWrapper/SectionWrapper';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import solicitudesPendientesNuevoOnboarding from 'services/remote/SolicitudesPendientesNuevoOnboarding';
// import { CommunitiesEnrolledListPaginator } from './components/communities-enrolled-list-paginator/communities-enrolled-list-paginator';

import styles from './comunities-solicitudes-pendiente-list-page-new-onboarding.module.scss';
import { SolicitudPendienteListPageFilter } from './components/comunities-solicitudes-pendiente-list-page-new-onboarding-filters/comunities-solicitudes-pendiente-list-page-new-onboarding-filters';
import { PendingRequestsTable } from './components/comunities-solicitudes-pendiente-list-page-new-onboarding-table/comunities-solicitudes-pendiente-list-page-new-onboarding-table';

interface ParameterDetalles {
  communityID: string;
}

export const SolicitudesAcabadaListPageNewOnboarding = (): JSX.Element => {
  const [solicitudPendiente, setSolicitudPendiente] = useState<SolicitudPendiente[]>([]);
  const { communityID } = useParams<ParameterDetalles>();
  const [searchParams, setSearchParams] = useState<string>('');
  const handleFilterChange = (value: any) => {
    setSearchParams(value);
  };

  useEffect(() => {
    const fetchSolicitudes = async () => {
      const filters: any = {};
      if (searchParams) filters.search_param = searchParams;
      if (communityID) filters.comunidad_id = Number(communityID);
      filters.acabadas = true; // Assuming you want to fetch only finished requests
      try {
        const response = await solicitudesPendientesNuevoOnboarding.getPendingRegistrationRequests(filters);
        const result = response;
        setSolicitudPendiente(result);
      } catch (err) {
        console.error('Error obteniendo solicitudes pendientes:', err);
      }
    };

    fetchSolicitudes();
  }, [searchParams, communityID]);
  return (
    <div className={communityID !== undefined ? styles.container : styles.container2}>
      {communityID !== undefined ? null : (
        <div className={styles.header}>
          <Button
            className={styles.viewmore_button}
            variant="tertiary"
            type="button"
            onClick={(): Promise<void> => navigate('/tecnic/dashboard')}
            text={I18n.t('UsersPage.goDashboard')}
          />
        </div>
      )}
      <SectionWrapper>
        <SolicitudPendienteListPageFilter handleChange={handleFilterChange} acabadas />

        <div className={styles.table_wrapper}>
          <PendingRequestsTable data={solicitudPendiente} communityID={communityID} />
        </div>
        <div>
          {/* <CommunitiesEnrolledListPaginator current={0} max={1} handleNext={() => {}} handlePrev={() => {}} /> */}
        </div>
      </SectionWrapper>
    </div>
  );
};
